import MobileDetect from 'mobile-detect'

const md = new MobileDetect(window.navigator.userAgent)

export default {
  iphone () {
    return md.os() === 'iOS' || md.os() === 'iPadOS'
  },
  facebookWebBrowser () {
    return md.match('FBAN') || md.match('FBAV')
  }
}
